import Script from 'next/script';

const POSTHOG_API_HOST = 'https://us.i.posthog.com';

export default function HeadScripts() {
  return (
    <>
      <Script
        data-posthog-api-host={POSTHOG_API_HOST}
        data-posthog-key={process.env.NEXT_PUBLIC_POSTHOG_API_KEY ?? ''}
        data-segment-key={process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY ?? ''}
        id="analytics-init"
        src="/scripts/analytics-init.js"
        strategy="afterInteractive"
      />
    </>
  );
}
